import React from "react";
import AllAdmin from "../pages/AdminPages/AllAdmin";
import AdminEdit from "../pages/AdminPages/AdminEdit";
import AllDrivers from "../pages/Driver/AllDrivers";
import EditDriver from "../pages/Driver/EditDriver";
import AllUser from "../pages/Users/AllUser";
import FormTwo from "../pages/Driver/AllForms/FormTwo";
import FormThree from "../pages/Driver/AllForms/FormThree";
import FormFour from "../pages/Driver/AllForms/FormFour";
import AllBooking from "../pages/AllBooking/AllBooking";
import WalletReport from "../pages/WalletReport/WalletReport";
import RaingAndReview from "../pages/RatingAndReview";

const Dashboard = React.lazy(() => import("../pages/AdminDashboard"));
const Demo = React.lazy(() => import("../pages/DemoTest"));

const routes = [
  { path: "/", exact: true, name: "Dashboard" },
  // { path: "/dashboard", name: "Dashboard", element: Dashboard },
  { path: "/Admin", name: "Admin", element: AllAdmin },
  { path: "/addAdmin", name: "Add Admin", element: AdminEdit },
  { path: "/manager", name: "Manager", element: AllAdmin },
  { path: "/addManager", name: "Add Manager", element: AdminEdit },
  { path: "/driver", name: "Driver", element: AllDrivers },
  { path: "/addDriver", name: "Add Driver", element: EditDriver },
  { path: "/addDriver2", name: "Add Driver", element: FormTwo },
  { path: "/addDriver3", name: "Add Driver", element: FormThree },
  { path: "/addDriver4", name: "Add Driver", element: FormFour },
  { path: "/customer", name: "Customer", element: AllUser },
  { path: "/allbooking", name: "Booking", element: AllBooking },
  { path: "/allWallet", name: "Wallet", element: WalletReport },
  { path: "/allReviews", name: "RatingAndReview", element: RaingAndReview },
  { path: "/demo", name: "Demo", element: Demo },
];

export default routes;
